import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { List, Map, fromJS } from 'immutable'

import DatePicker from 'components/DatePicker'
import Select from 'components/Select'
import Calendar from 'components/Calendar'
import OccasionPopup from 'components/OccasionPopup'

import { range, title } from 'utilities'
import styles from './styles.css'

moment.locale('sv')
export const DateField = ({ value, onChange }) => (
  <DatePicker value={value} onChange={onChange} />
)

DateField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

DateField.defaultProps = {
  value: '',
}

export const TimeField = ({ value, onChange, hours, ...props }) => {
  const options =
    hours ||
    range(24)
      .map(h => h * 100)
      .map(hour => `0000${hour}`.slice(-4))
      .map(hour => `${hour}:00`)
      .map(hour => `${hour.slice(0, 2)}:${hour.slice(2)}`)

  const v = value || options[0]
  return (
    <Select
      {...props}
      options={options.map(hour => ({
        label: hour.slice(0, -3),
        value: hour,
      }))}
      value={v}
      onChange={onChange}
    />
  )
}

TimeField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  hours: PropTypes.arrayOf(PropTypes.string),
}

TimeField.defaultProps = {
  value: '',
  hours: undefined,
}

export const DayField = ({ value, onChange }) => (
  <Select
    options={range(7).map(day => ({
      label: title(moment.weekdays(day + 1)),
      value: `${day}`,
    }))}
    value={`${value}`}
    onChange={onChange}
  />
)

DayField.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
}

DayField.defaultProps = {
  value: '',
}

const CalendarField = ({ schedule, onChange, value, ...rest }) => {
  const calendar = (
    value || Map({ instances: List(), selectedDay: null })
  ).toJS()
  const { instances = [], month } = calendar
  const selectedDays = instances && instances.map(d => d.from_dt)

  const renderDay = day => {
    const { selectedDay } = calendar

    if (selectedDay && moment(selectedDay).isSame(day, 'day')) {
      return (
        <React.Fragment>
          <OccasionPopup
            day={day}
            onChange={onChange}
            calendar={calendar}
            schedule={schedule}
          />
          {day.getDate()}
        </React.Fragment>
      )
    }
    return day.getDate()
  }

  return (
    <React.Fragment>
      <Calendar
        className={styles.calendarField}
        onChangeMonth={m => onChange(fromJS({ ...calendar, month: m }))}
        selectedDays={selectedDays}
        onDayClick={(day, modifiers, e) => {
          e.preventDefault()
          const node = e.target

          // Ignore click event for nested buttons
          if (node.tagName === 'BUTTON') {
            return
          }

          onChange(fromJS({ ...calendar, selectedDay: day }))
        }}
        renderDay={day => renderDay(day)}
        schedule={schedule}
        month={month || null}
        {...rest}
      />
    </React.Fragment>
  )
}

CalendarField.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.object,
    PropTypes.array,
  ]),
  onChange: PropTypes.func.isRequired,
  schedule: PropTypes.array,
}

CalendarField.defaultProps = {
  value: [],
  schedule: [],
}

export { CalendarField }

export default {
  DateField,
  DayField,
  TimeField,
  CalendarField,
}



// WEBPACK FOOTER //
// ../source/forms/fields.js